import React, { Component } from "react";
import Button from "../../button/components/ButtonComponent";
import isMobile from "is-mobile";
import RegisterModalComponent from "../../../../shared/registermodal/components/RegisterModalComponent";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { createBrowserHistory } from "history";
import Menu from "../../../../shared/header/components/Menu";

export const history = createBrowserHistory();

const Style = require("../styles/NavbarComponent.scss");

class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
      showRegister: false,
      selectedIndexMenu: 0,
    };
    this.openMenu = this.openMenu.bind(this);
  }

  openMenu() {
    let menu = document.getElementById('navLanding');
    menu.style.display = 'flex';
  }

  closeMenuMobile() {
    let menu = document.getElementById('navLanding');
    menu.style.display = 'none';
  }

  back() {
    history.goBack();
  }

  render() {
    const { navEvento, t } = this.props;
    const accountPoweredByBlanc = Number(
      localStorage.getItem("xAccountPoweredByBlanc")
    );
    const xAccountLogo = localStorage.getItem("xAccountLogo");
    const xAccountTitle = localStorage.getItem("xAccountTitle");
    const showPoweredByBlanc =
      navEvento || accountPoweredByBlanc ? true : false;

    return (
      <>
        <div className="align-nav">
          <div
            style={{ display: showPoweredByBlanc ? "none" : undefined }}
            className="open-menu-wrapper"
          >     
            <img
              src={xAccountLogo}
              className="logo-desk"
              alt={xAccountTitle}
              onClick={() => {
                return window.location.pathname !== "/" ? this.back() : "";
              }}
            />

            <div className="openMenuMobile" onClick={this.openMenu}>
              <span />
              <span />
              <span />
            </div>
          </div>

          <nav
            style={{
              justifyContent: showPoweredByBlanc ? "flex-end" : undefined,
            }}
            className={Style.nav}
            id="navLanding"
          >
            <div
              style={{
                justifyContent: showPoweredByBlanc ? "flex-end" : undefined,
              }}
              className={`MenuResponsive show-mb ${
                this.state.openMenu ? "showMenu" : ""
              }`}
            >
              <div
                className="logo-wrapper mobile logo-wrapper--xAccount"
                style={{
                  display:
                    showPoweredByBlanc && !accountPoweredByBlanc
                      ? "none"
                      : undefined,
                }}
              >
                <img
                  src={xAccountLogo}
                  className="logo-desk"
                  alt={xAccountTitle}
                  onClick={() => {
                    return window.location.pathname !== "/" ? this.back() : "";
                  }}
                />

                <div id='closeMenu' onClick={() => this.closeMenuMobile()}>
                  <img src='/images/close-icon.svg' alt="Close"/>
                </div>
              </div>
            </div>

            <div
              className="logo-wrapper"
              style={{
                display:
                  showPoweredByBlanc && !accountPoweredByBlanc
                    ? "none"
                    : undefined,
              }}
            >
              <img
                src={xAccountLogo}
                className="logo-desk"
                alt={xAccountTitle}
                onClick={() => {
                  return window.location.pathname !== "/" ? this.back() : "";
                }}
              />
            </div>

            <h1
              style={{ display: !showPoweredByBlanc ? "none" : undefined }}
              className={`logo ${
                accountPoweredByBlanc ? "logo--powered-by" : ""
              }`}
            >
              <span>{t('Powered by', 'Powered by')}</span>
              <Link to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logo.svg`}
                  alt="logo"
                />
              </Link>
            </h1>

            <div
              style={{ display: showPoweredByBlanc ? "none" : undefined }}
              className={`itens ${this.state.openMenu ? "showMenu" : ""}`}
            >
              <ul>
                <li>
                  <a
                    onClick={() =>
                      this.setState({ openMenu: false, selectedIndexMenu: 1 })
                    }
                    href="/brands"
                    className={
                      this.state.selectedIndexMenu === 1 ? "selected" : ""
                    }
                  >
                    {t("Brands", "Brands")}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      this.setState({ openMenu: false, selectedIndexMenu: 2 })
                    }
                    href="/brands?segments=13"
                    className={
                      this.state.selectedIndexMenu === 2 ? "selected" : ""
                    }
                  >
                    {t("Women", "Women")}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      this.setState({ openMenu: false, selectedIndexMenu: 3 })
                    }
                    href="/brands?segments=14"
                    className={
                      this.state.selectedIndexMenu === 3 ? "selected" : ""
                    }
                  >
                    {t("Men", "Men")}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      this.setState({ openMenu: false, selectedIndexMenu: 4 })
                    }
                    href="/brands?segments=15"
                    className={
                      this.state.selectedIndexMenu === 4 ? "selected" : ""
                    }
                  >
                    {t("Children", "Children")}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      this.setState({ openMenu: false, selectedIndexMenu: 5 })
                    }
                    href="/brands?segments=16"
                    className={
                      this.state.selectedIndexMenu === 5 ? "selected" : ""
                    }
                  >
                    {t("Home & Beauty", "Home & Beauty")}
                  </a>
                </li>
              </ul>
            </div>

            <div className="wrapper-last-infos">
              <a
                onClick={() =>
                  this.setState({ openMenu: false, selectedIndexMenu: 6 })
                }
                href="https://www.blanc.global/"
                target="_blank" 
                rel="noopener noreferrer"
                className={`outlined-button ${this.state.selectedIndexMenu === 6 ? "selected" : ""}`}
              >
                {t("I'M A BRAND", "I'M A BRAND")}
              </a>

              <button className="outlined-button login-button" onClick={this.props.showLogin}>{t("LOGIN", "LOGIN")}</button>
                
              <button className="register-button" onClick={() => this.setState({ showRegister: true })}>
                {t("register as a buyer", "register as a buyer")}
              </button>

              <Menu />
            </div>

            <div className="wrapper-global-links-and-social">
              <div className="new-menu__list--item">
                  <div className="new-menu__list--item__subitem">
                      <a href="https://www.blanc.global/">About BLANC*</a>
                      <a href="https://news.blancfashion.com/">News and Views</a>
                      <a href="https://www.blanc.global/contact-us">Get in touch</a>
                  </div>
              </div>

              <div className="bottom-items icons">
                  <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/blancfashionglobal/">
                      <img src="/images/icon-instagram.svg" alt="Instagram"/>
                  </a>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/blancfashionbr/">
                      <img src="/images/icon-facebook.svg" alt="Facebook"/>
                  </a>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/blanc-fashion/">
                      <img src="/images/icon-linkedin.svg" alt="Linkedin"/>
                  </a>
              </div>
            </div>
          </nav>
        </div>
        
        <div id="shadowNav"></div>
        {this.state.showRegister && (
          <RegisterModalComponent
            close={() => this.setState({ showRegister: false })}
          />
        )}
      </>
    );
  }
}

export default withTranslation()(NavbarComponent);
